// extracted by mini-css-extract-plugin
export var container = "_h1-0";
export var content = "_h1-3";
export var customerTitle = "_h1-4";
export var empty = "_h1-5";
export var gray = "_h1-6";
export var header = "_h1-7";
export var info = "_h1-8";
export var loading = "_h1-2";
export var loadingCard = "_h1-9";
export var oneLine = "_h1-a";
export var personName = "_h1-e";
export var pillContainer = "_h1-b";
export var selected = "_h1-1";
export var text = "_h1-c";
export var twoLines = "_h1-d";
export var unread = "_h1-f";
export var unreadIndicator = "_h1-g";